import React from "react";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { get, filter, map, includes, toLower, isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";

import { fetchGet, fetchPost } from "../../../api/fetch";

import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import {
  SET_PROFILE_INFO,
  PROFILE_CREATED,
  ADD_PHOTOS,
  SAVING_PHOTOS,
  PHOTOS_SAVED,
  DATA_POLICY,
  ENROLLING,
  ENROLLMENT_DONE,
  ENROLLMENT_FAILED,
} from "../../../constants/profiles";
import { API_LUKE } from "../../../constants/api";

import Loader from "../../Common/Loader";
import ProfileCreated from "./ProfileCreated";
import AddPhotos from "./AddPhotos";
import PhotosSaved from "./PhotosSaved";
import ProfileForm from "../ProfileForm/ProfileForm";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";
import DataPolicy from "./DataPolicy";
import EnrollmentStatus from "./EnrollmentStatus";

const styles = {
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    maxWidth: "1472px",
    maxHeight: "calc(100vh - 60px)",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px 24px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1em",
    margin: "20px",
    color: colors.black54,
  },
  postCreationBtn: {
    margin: "10px 0px",
  },
  titleBarItem: {
    display: "flex",
    alignItems: "center",
  },
  menuItem: {
    padding: "15px 30px",
    fontSize: "1em",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  itemIcon: {
    width: "35px",
    minWidth: "unset",
    marginRight: "15px",
  },
};

const AddProfile = (props) => {
  const { classes, language, defaultOpen } = props;
  const [open, setOpen] = React.useState(false);
  const [step, setStep] = React.useState(SET_PROFILE_INFO);
  const [lov, setLov] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [profileType, setProfileType] = React.useState();
  const [createdProfile, setCreatedProfile] = React.useState({});
  const [photos, setPhotos] = React.useState([]);

  React.useEffect(() => {
    const fetchProfileTypes = async () => {
      try {
        const profileType = await fetchGet("profile_types");
        setLov({
          profileType,
        });
        if (defaultOpen) {
          selectProfileType(defaultOpen, profileType);
        }
      } catch (e) {
        console.log(e);
      }
    };
    fetchProfileTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (defaultOpen && !isEmpty(get(lov, ["profileType"]))) {
      selectProfileType(defaultOpen, get(lov, ["profileType"]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultOpen]);

  const selectProfileType = (newType, profileTypes) => {
    const type = get(
      filter(
        profileTypes,
        (type) => toLower(get(type, ["name_en"])) === newType
      ),
      [0, "id"]
    );
    if (type) {
      setProfileType(type);
      setOpen(true);
    } else {
      closeDialog();
    }
  };

  const reset = () => {
    setStep(SET_PROFILE_INFO);
    setCreatedProfile({});
    setPhotos([]);
  };

  const closeDialog = () => {
    reset();
    setOpen(false);
    props.history.push("/profiles");
  };

  const savePhotos = async (changeStep = true) => {
    try {
      if (changeStep) setStep(SAVING_PHOTOS);
      for (let i = 0; i < photos.length; i++) {
        let body = {
          name: uuidv4(),
          enrollment_status: false,
          enrollment_error: false,
          main_display: false,
          "image-base64": photos[i],
        };
        await fetchPost("profiles/" + createdProfile.id + "/images", body);
        console.log("image added to profile");
      }
      if (changeStep) setStep(PHOTOS_SAVED);
    } catch (e) {
      console.log(e);
    }
  };

  const saveAndEnroll = async () => {
    try {
      setStep(ENROLLING);
      await savePhotos(false);
      await fetchPost(`profiles/${createdProfile.id}/index`, {}, API_LUKE);
      setTimeout(async () => {
        let indexationResult = await fetchGet(
          `profiles/${createdProfile.id}/index`,
          API_LUKE
        );
        console.log(indexationResult);
        if (
          indexationResult &&
          indexationResult.data &&
          indexationResult.data.completed !== undefined
        ) {
          if (indexationResult.data.completed === true) {
            setStep(ENROLLMENT_DONE);
          } else {
            setStep(ENROLLMENT_FAILED);
          }
        }
      }, 10000);
    } catch (e) {
      console.log(e);
      setStep(ENROLLMENT_FAILED);
    }
  };

  return (
    <>
      <Box style={{ marginRight: "30px", marginTop: "7px" }}>
        <img
          src={images.plusIconColored}
          alt="add"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          style={{ cursor: "pointer" }}
          aria-controls="simple-menu"
          aria-haspopup="true"
        />
        {lov.profileType && (
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            // MenuListProps={{ onMouseLeave: () => setAnchorEl(null) }}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            getContentAnchorEl={null}
          >
            {map(
              filter(get(lov, ["profileType"]), (p) => p.active),
              (profileType, index) => (
                <MenuItem
                  key={index}
                  classes={{ root: classes.menuItem }}
                  alignItems="center"
                  onClick={() => {
                    setAnchorEl(null);
                    props.history.push(
                      `/profiles/creation/${toLower(
                        get(profileType, ["name_en"])
                      )}`
                    );
                  }}
                  style={{ paddingLeft: "0px !important" }}
                >
                  <ListItemIcon
                    classes={{ root: classes.itemIcon }}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    {includes([1, 2, 3, 4, 5, 6, 8], profileType.id) && (
                      <img
                        src={
                          profileType.id === 1
                            ? images.humanIconBlack
                            : profileType.id === 2
                            ? images.truckIconBlack
                            : profileType.id === 3
                            ? images.trailerIconBlack
                            : profileType.id === 4
                            ? images.containerIconBlack
                            : profileType.id === 5
                            ? images.paletteIconBlack
                            : profileType.id === 6
                            ? images.notificationIconBlack
                            : profileType.id === 8
                            ? images.locomotiveIcon
                            : null
                        }
                        height="20px"
                        style={{ maxWidth: "35px", filter: "invert(0%) sepia(100%) saturate(0%) hue-rotate(21deg) brightness(97%) contrast(103%)"}}
                        alt="profile_icon"
                      />
                    )}
                  </ListItemIcon>
                  {profileType[`name_${language}`]}
                </MenuItem>
              )
            )}
          </Menu>
        )}
      </Box>
      <Dialog
        open={open}
        classes={{
          root: classes.dialogRoot,
          paperScrollPaper: classes.dialog,
        }}
      >
        {step === SET_PROFILE_INFO ? (
          <ProfileForm
            profileType={profileType}
            permission={true}
            profileTypeDetails={get(
              filter(get(lov, ["profileType"]), (p) => p.id === profileType),
              [0]
            )}
            close={closeDialog}
            setCreatedProfile={(profile) => {
              setCreatedProfile(profile);
              setStep(PROFILE_CREATED);
              props.onProfileCreated();
            }}
            disablePhotos={true}
          />
        ) : step === PROFILE_CREATED ? (
          <ProfileCreated
            setStep={setStep}
            profile={createdProfile}
            close={closeDialog}
            classes={classes}
            addAnotherProfile={reset}
          />
        ) : step === ADD_PHOTOS ? (
          <AddPhotos
            photos={photos}
            setPhotos={setPhotos}
            savePhotos={savePhotos}
            close={closeDialog}
            classes={classes}
            setStep={setStep}
            onlySave={profileType !== 1}
          />
        ) : step === SAVING_PHOTOS ? (
          <Loader
            message={I18n.get("profiles_savingPhotos")}
            width="500px"
            height="300px"
          />
        ) : step === PHOTOS_SAVED ? (
          <PhotosSaved
            profileId={createdProfile.id}
            close={closeDialog}
            classes={classes}
            photosNb={photos.length}
            addAnotherProfile={reset}
          />
        ) : step === DATA_POLICY ? (
          <DataPolicy
            close={closeDialog}
            classes={classes}
            photos={photos}
            savePhotos={savePhotos}
            saveAndEnroll={saveAndEnroll}
          />
        ) : step === ENROLLING ? (
          <Loader
            message={I18n.get("profiles_enrolling")}
            width="500px"
            height="300px"
          />
        ) : step === ENROLLMENT_DONE ? (
          <EnrollmentStatus
            profileId={createdProfile.id}
            close={closeDialog}
            classes={classes}
            addAnotherProfile={reset}
            status={ENROLLMENT_DONE}
          />
        ) : step === ENROLLMENT_FAILED ? (
          <EnrollmentStatus
            profileId={createdProfile.id}
            close={closeDialog}
            classes={classes}
            addAnotherProfile={reset}
            status={ENROLLMENT_FAILED}
          />
        ) : (
          <></>
        )}
      </Dialog>
    </>
  );
};

AddProfile.propTypes = {
  language: PropTypes.oneOf(["en", "fr"]).isRequired,
};

export default withRouter(withStyles(styles)(AddProfile));
